/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;color:inherit}[_nghost-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:.7rem}[_nghost-%COMP%]   ul[_ngcontent-%COMP%]   i.circle[_ngcontent-%COMP%]{font-size:.6rem}[_nghost-%COMP%]   .store-badge[_ngcontent-%COMP%]{height:40px}"];
export { styles as styles };
